<template>
    <select name="" id="" :value="currency" v-on:change="currencyChange($event)" class="mx-2 bg-transparent rounded-lg text-enriqueto_green">
        <option value="USD">USD</option>
        <option value="COP">COP</option>
        <option value="BTC">BTC</option>
    </select>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'

export default {
    setup(){
        const store = useStore()
        const currencyChange = (event) => store.commit('changeCurrency',event.target.value)
        const currency = computed(() => store.state.currency);

        if (store.state.currency === 'ETH') {
            store.commit('changeCurrency', 'USD')
        }

        const coinGecko = async()=>{
            try {
                const res = await fetch(
                    "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&ids=bitcoin&order=market_cap_desc&per_page=1&page=1&sparkline=false"
                );
                if (!res.ok) return;

                const data = await res.json();
                if (Array.isArray(data) && data[0]?.current_price) {
                    store.commit('setCurrencies', data)
                }
            } catch (error) {
                // Keep the last stored rate when the external service is unavailable.
            }
        }

        const usdPrice = async()=>{
            try {
                const res = await fetch(
                    "https://www.floatrates.com/daily/cop.json"
                );
                if (!res.ok) return;

                const data = await res.json();
                if (Number(data?.usd?.inverseRate) > 0) {
                    store.commit('setUsdRate', data.usd.inverseRate)
                }
            } catch (error) {
                // Keep the last stored rate when the external service is unavailable.
            }
        }

        coinGecko()
        usdPrice()

        return{
            currencyChange,
            currency
        }
    }
}
</script>

<style>

</style>
